import React from "react";
import "../Products/Products.css";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
const MetalDetection = ({ title, imageSrc, description }) => {
  const MetalDetectionDetails = [
    {
      headingname: "Metal Detector",
      detailsname:"You can use Control Panel to change settings for Windows. These settings control nearly ............",
      imageSource:process.env.PUBLIC_URL + "assets/images/Products/metal-1.png",
    },
    {
      headingname: "Metal Detector",
      detailsname:"GSM alarm systems can be a great addition to your home security set-up. GSM stands for Global........",
      imageSource:process.env.PUBLIC_URL +"assets/images/Products/metal-2.png",
    },
    {
      headingname: "Metal Detector ",
      detailsname:"A passive infrared (PIR) sensor (Fig. 5) is an electronic sensor that measures..........",
      imageSource:process.env.PUBLIC_URL +"assets/images/Products/metal-3.png",
    },
    {
      headingname: "Door Metal Detector",
      detailsname:"They are an audible part of a fire alarm system, and their primary function is to produce a loud.....",
      imageSource:process.env.PUBLIC_URL +"assets/images/Products/metal-4.png" ,
    },
    {
      headingname: "Metal Detector",
      detailsname:"an alarm system is used to provide early warning of an intruder. There are three components.....",
      imageSource:process.env.PUBLIC_URL +"assets/images/Products/metal-5.png ",
    },
  ];
  return (
    <>
      <section className="CCTV-System">
        <div className="container">
          <div className="Heading-cctv">
            <div className="heading-about text-center">
              <h4>Metal Detection System</h4>
            </div>
            <div className="borders-five d-flex justify-content-center">
              <div className="border-red"></div>
              <div className="border-line "></div>
            </div>
          </div>

          <div className="row justify-content-center">
            {MetalDetectionDetails.map((item, index) => (
              <div key={index} className="col-xxl-4 col-xl-4 col-lg-6 col-md-6 col-12 mt-4 mt-xl-5 g-5">
                <Card className="IR-Camera mb-3">
                  <Card.Img variant="top" />
                  <div className="Heading-Main">
                    <h1 className="dome-camera">{item.headingname}</h1>
                  </div>

                  <div className="camera-border"></div>
                  <div className="IR-camera-img">
                    <img src={item.imageSource} className="camera-img" />
                  </div>
                  <Card.Body className="IR-Camera-body">
                    <Card.Text>{item.detailsname}</Card.Text>
                    <div className="read-button">
                      <Button variant="read">Read More</Button>
                      <div className="read-border"></div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default MetalDetection;
